<template>
  <div :class="`auth-page ${layoutClass}`">
    <div
      v-if="isNotLogin"
      class="auth-page__back"
      @click="onBack"
      v-html="leftArr"
    ></div>
    <div class="auth-page__lang" @click="isLangOpened = true">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.4245 4.58154C18.4513 3.59865 17.2934 2.81775 16.0174 2.28369C14.7414 1.74964 13.3725 1.47296 11.9893 1.46956C10.6061 1.46616 9.23579 1.73609 7.9572 2.26386C6.67862 2.79162 5.51691 3.56682 4.53882 4.54491C3.56073 5.523 2.78553 6.68471 2.25777 7.96329C1.73 9.24188 1.46007 10.6121 1.46347 11.9954C1.46688 13.3786 1.74355 14.7475 2.27761 16.0235C2.81166 17.2995 3.59256 18.4573 4.57546 19.4306C5.54872 20.4135 6.7066 21.1944 7.98257 21.7285C9.25855 22.2625 10.6275 22.5392 12.0107 22.5426C13.3939 22.546 14.7642 22.2761 16.0428 21.7483C17.3214 21.2205 18.4831 20.4453 19.4612 19.4672C20.4392 18.4892 21.2144 17.3274 21.7422 16.0489C22.27 14.7703 22.5399 13.4 22.5365 12.0168C22.5331 10.6336 22.2564 9.26463 21.7224 7.98866C21.1883 6.71269 20.4074 5.55481 19.4245 4.58154ZM2.99999 12.0061C2.99965 11.2095 3.10526 10.4165 3.31405 9.64779C3.65811 10.3884 4.1578 11.0283 4.49764 11.7881C4.93686 12.765 6.11624 12.494 6.63702 13.35C7.09921 14.1098 6.60561 15.0708 6.95155 15.8658C7.2028 16.4428 7.7953 16.5689 8.20405 16.9908C8.62171 17.4164 8.6128 17.9995 8.67655 18.5545C8.74849 19.2066 8.86517 19.853 9.02577 20.489C9.02577 20.4937 9.02577 20.4989 9.02952 20.5036C5.52186 19.2717 2.99999 15.9281 2.99999 12.0061ZM12 21.0061C11.4974 21.0059 10.9956 20.9639 10.5 20.8805C10.5051 20.7534 10.5075 20.6348 10.5201 20.5523C10.634 19.807 11.0072 19.0781 11.5106 18.5203C12.008 17.97 12.6895 17.5978 13.1095 16.9734C13.5211 16.364 13.6444 15.5437 13.4747 14.8317C13.2248 13.7798 11.7956 13.4287 11.025 12.8583C10.582 12.5301 10.1878 12.023 9.60608 11.9817C9.33796 11.963 9.11342 12.0206 8.84764 11.9522C8.60389 11.8889 8.41264 11.7576 8.15296 11.7919C7.6678 11.8556 7.36171 12.374 6.84046 12.3037C6.34592 12.2376 5.83639 11.6587 5.72389 11.1876C5.57952 10.582 6.05858 10.3856 6.57186 10.3317C6.78608 10.3092 7.02655 10.2848 7.23233 10.3636C7.50327 10.4639 7.63124 10.7292 7.87452 10.8633C8.33061 11.1136 8.42296 10.7137 8.35311 10.3087C8.24858 9.70217 8.12671 9.45514 8.66764 9.03748C9.04264 8.74967 9.36327 8.54154 9.30327 8.02451C9.26764 7.72076 9.10124 7.58342 9.25639 7.28108C9.37405 7.05092 9.69702 6.84326 9.90749 6.70592C10.4508 6.35154 12.2348 6.37779 11.5059 5.38592C11.2917 5.09483 10.8966 4.57451 10.5216 4.50326C10.0528 4.41467 9.84468 4.93779 9.51796 5.16842C9.18046 5.40701 8.52327 5.67795 8.1853 5.30904C7.73061 4.81264 8.48671 4.64998 8.65405 4.30311C8.73139 4.14139 8.65405 3.91686 8.52374 3.70545C8.6928 3.6342 8.86467 3.56811 9.03936 3.50717C9.14884 3.58803 9.27871 3.63673 9.41436 3.64779C9.72796 3.66842 10.0237 3.49873 10.2975 3.71248C10.6012 3.94686 10.8201 4.24311 11.2233 4.31623C11.6133 4.38701 12.0262 4.15967 12.1228 3.76029C12.1814 3.51748 12.1228 3.26108 12.0666 3.01029C13.8197 3.02038 15.5312 3.54541 16.9884 4.52014C16.8947 4.48451 16.7826 4.48873 16.6444 4.55295C16.3598 4.68514 15.9567 5.0217 15.9234 5.35545C15.8855 5.7342 16.4442 5.78764 16.7095 5.78764C17.108 5.78764 17.5116 5.60951 17.3831 5.1492C17.3273 4.94951 17.2514 4.74186 17.1291 4.61623C17.4231 4.82031 17.7049 5.04163 17.9728 5.27904C17.9686 5.28326 17.9644 5.28701 17.9601 5.2917C17.6901 5.57295 17.3766 5.79561 17.1919 6.13779C17.0616 6.37873 16.9148 6.49311 16.6509 6.55545C16.5056 6.58967 16.3397 6.60233 16.2178 6.69983C15.8784 6.96701 16.0716 7.6092 16.3931 7.80186C16.7995 8.04514 17.4023 7.93076 17.7089 7.58342C17.9484 7.31154 18.0895 6.83951 18.5203 6.83998C18.71 6.83959 18.8921 6.91384 19.0275 7.0467C19.2056 7.23139 19.1705 7.40389 19.2084 7.63451C19.2755 8.0442 19.6369 7.82201 19.8567 7.61529C20.017 7.90049 20.1615 8.19421 20.2898 8.49514C20.048 8.84342 19.8558 9.22311 19.274 8.81717C18.9258 8.57389 18.7116 8.22092 18.2742 8.11123C17.8922 8.01748 17.5008 8.11498 17.1234 8.18014C16.6945 8.25467 16.1859 8.28748 15.8606 8.61233C15.5461 8.92545 15.3797 9.34451 15.045 9.65904C14.3976 10.2684 14.1244 10.9336 14.5434 11.7951C14.9466 12.6234 15.7898 13.073 16.6997 13.0139C17.5936 12.9544 18.5222 12.4359 18.4964 13.7348C18.487 14.1947 18.5831 14.513 18.7242 14.94C18.855 15.3337 18.8461 15.7153 18.8761 16.1217C18.9046 16.5976 18.979 17.0696 19.0983 17.5312C18.2581 18.613 17.1818 19.4884 15.9515 20.0907C14.7213 20.6929 13.3697 21.006 12 21.0061Z"
          fill="#000"
        />
      </svg>
      <span>{{ currentLang.short }}</span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.1431 9.42941L12.0003 14.5723L6.85742 9.42941"
          stroke="#000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div @click="isSocialOpened = true" class="auth-page__help">
      <img src="@/assets/img/i-support.svg" />
    </div>
    <social-help :isSocialOpened.sync="isSocialOpened" />

    <slot />

    <easy-bottom-sheet
      :isOpened.sync="isLangOpened"
      :title="$t('changeLangTitle')"
    >
      <div class="profile-lang__container">
        <div
          class="profile-lang__item"
          v-for="(o, i) in LOCALES"
          :key="i"
          @click="onChangeLang(o.value)"
        >
          <div
            class="profile-lang__checkbox"
            :class="{ isActive: o.value === $i18n.locale }"
          >
            <img src="@/assets/img/i-success.svg" />
          </div>
          <div class="profile-lang__label">{{ o.caption }}</div>
        </div>
      </div>
    </easy-bottom-sheet>
  </div>
</template>

<script>
import SocialHelp from "@/components/SocialHelp.vue";
import { leftArr } from "@/services/svg";
import { mapMutations, mapActions } from "vuex";
import { LOCALES, defaultLocale } from "@/locales/locales";
import EasyBottomSheet from "@/components/common/EasyBottomSheet.vue";

export default {
  name: "AuthLayout",
  components: { SocialHelp, EasyBottomSheet },
  props: {
    layoutClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      LOCALES,
      defaultLocale,
      leftArr,
      isSocialOpened: false,
      isLangOpened: false,
    };
  },
  async created() {
    await this.getUserDataByIP();
  },
  computed: {
    isNotLogin() {
      return this.$route.name !== "LoginPage";
    },
    currentLang() {
      return this.LOCALES.find((o) => o.value === this.$i18n.locale);
    },
  },
  methods: {
    ...mapActions("root", ["getUserDataByIP"]),
    ...mapMutations("root", ["setLanguage"]),
    onBack() {
      this.$router.push("/login");
    },
    onChangeLang(lang) {
      this.setLanguage(lang);
      this.isLangOpened = false;
    },
  },
};
</script>

<style lang="scss"></style>
